export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';
export const IDLE = '_IDLE';

export const idle = 'idle';
export const pending = 'pending';
export const morePending = 'morePending';
export const fulfilled = 'fulfilled';
export const rejected = 'rejected';
